/**
 * `data.type` values for postMessage from the chat iframe to the embedding parent.
 * Use `CHATYME_EMBED_HOST_MESSAGE_TYPE` everywhere (do not duplicate string literals).
 * Keep `public/chatyme.js` object `CHATYME_EMBED_HOST_MESSAGE_TYPE` in sync with these values.
 */
export const CHATYME_EMBED_HOST_MESSAGE_TYPE = {
  IFRAME_LOADED: 'CHATYME_IFRAME_LOADED',
  CHAT_CONNECTED: 'CHATYME_CHAT_CONNECTED',
  CHAT_TOKEN_EXPIRED: 'CHATYME_CHAT_TOKEN_EXPIRED',
  CHAT_DISCONNECTED: 'CHATYME_CHAT_DISCONNECTED',
  CHAT_UNREAD_COUNT: 'CHATYME_CHAT_UNREAD_COUNT',
  CHAT_UNASSIGNED_COUNT: 'CHATYME_CHAT_UNASSIGNED_COUNT',
  CHAT_SESSION_ENDED: 'CHATYME_CHAT_SESSION_ENDED',
  CHAT_SESSION_CLOSED: 'CHATYME_CHAT_SESSION_CLOSED',
  /** Agent iframe: agent requested transfer of the current session to a phone call on the host. */
  CHAT_TRANSFER_TO_PHONE: 'CHATYME_CHAT_TRANSFER_TO_PHONE',
  /** Client iframe: full chat UI teardown (overlay / widget closed). */
  CLIENT_CHAT_CLOSED: 'CHATYME_CLIENT_CHAT_CLOSED',
  CHAT_MINIMIZED: 'CHATYME_CHAT_MINIMIZED',
  CHAT_IFRAME_VISIBILITY_CHANGED: 'CHATYME_CHAT_IFRAME_VISIBILITY_CHANGED',
  AGENT_CONFIG_UPDATED: 'CHATYME_AGENT_CONFIG_UPDATED',
  REPORT_LIVE_CHAT_SESSIONS: 'CHATYME_REPORT_LIVE_CHAT_SESSIONS',
  REPORT_PROMPT_EVAL_RUNS: 'CHATYME_REPORT_PROMPT_EVAL_RUNS'
} as const;

export type ChatymeEmbedHostMessageTypeValue =
  (typeof CHATYME_EMBED_HOST_MESSAGE_TYPE)[keyof typeof CHATYME_EMBED_HOST_MESSAGE_TYPE];
